module.exports = __webpack_public_path__ + "img/service-juece3.d486735f.svg";